import { extends as _extends, toConsumableArray as _toConsumableArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import 'react';
import { jsx } from '@emotion/react';

function renderNode(node, components) {
  var _node$key, _cache$children;
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var cache = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var Component = components[node.type];
  if (!Component) {
    console.error("Invalid component type: ".concat(node.type));
    return null;
  }
  var pathKey = (_node$key = node.key) !== null && _node$key !== void 0 ? _node$key : path[path.length - 1];
  // Check if the cache can be reused
  if (cache.node === node && cache.element != null) {
    return cache.element;
  }
  var childrenArr = (_cache$children = cache.children) !== null && _cache$children !== void 0 ? _cache$children : [];
  cache.children = childrenArr;
  var result;
  if (node.children.length > 0) {
    result = jsx(Component, _extends({}, node.props, {
      key: pathKey,
      path: path
    }), node.children.map(function (node, i) {
      var _childrenArr$i;
      var childCache = (_childrenArr$i = childrenArr[i]) !== null && _childrenArr$i !== void 0 ? _childrenArr$i : {};
      var result = renderNode(node, components, [].concat(_toConsumableArray(path), [i]), childCache);
      childrenArr[i] = childCache;
      return result;
    }));
  } else {
    result = jsx(Component, _extends({}, node.props, {
      key: pathKey,
      path: path
    }));
  }
  cache.node = node;
  cache.element = result;
  return result;
}

export { renderNode };
//# sourceMappingURL=renderNode.js.map
